import { FormStep } from '../types/onboarding';

export const FORM_STEPS: FormStep[] = [
  {
    id: 'welcome',
    title: 'Welcome',
    description: 'Let\'s get started with your intelligent outreach campaign',
    isCompleted: false,
    isActive: true,
    estimatedTime: 1,
  },
  {
    id: 'company',
    title: 'Company Details',
    description: 'Tell us about your company and what you offer',
    isCompleted: false,
    isActive: false,
    estimatedTime: 3,
  },
  {
    id: 'targeting',
    title: 'Target Audience',
    description: 'Define your ideal customers in natural language',
    isCompleted: false,
    isActive: false,
    estimatedTime: 5,
  },
  {
    id: 'goals',
    title: 'Campaign Goals',
    description: 'Set your objectives and preferences',
    isCompleted: false,
    isActive: false,
    estimatedTime: 3,
  },
  {
    id: 'review',
    title: 'Review & Launch',
    description: 'Preview your setup and launch your campaign',
    isCompleted: false,
    isActive: false,
    estimatedTime: 2,
  },
];

export const INDUSTRIES = [
  'Technology',
  'Healthcare',
  'Financial Services',
  'Manufacturing',
  'Retail & E-commerce',
  'Professional Services',
  'Real Estate',
  'Education',
  'Marketing & Advertising',
  'Construction',
  'Transportation & Logistics',
  'Energy & Utilities',
  'Government',
  'Non-profit',
  'Media & Entertainment',
  'Telecommunications',
  'Food & Beverage',
  'Automotive',
  'Legal',
  'Insurance',
];

export const COMPANY_SIZES = [
  'Startup (1-10 employees)',
  'Small Business (11-50 employees)',
  'Medium Business (51-200 employees)',
  'Large Enterprise (201-1000 employees)',
  'Enterprise (1000+ employees)',
];

export const LOCATIONS = [
  'North America',
  'United States',
  'Canada',
  'Europe',
  'United Kingdom',
  'Germany',
  'France',
  'Netherlands',
  'Asia Pacific',
  'Australia',
  'Japan',
  'Singapore',
  'Global/Remote',
];

export const JOB_TITLES = [
  'CEO',
  'Founder',
  'CTO',
  'CRO',
  'VP Sales',
  'VP Marketing',
  'Director of Sales',
  'Director of Marketing',
  'Sales Manager',
  'Marketing Manager',
  'Head of Growth',
  'Head of Business Development',
  'Business Development Manager',
  'Account Executive',
  'Sales Development Representative',
  'Marketing Director',
  'Chief Marketing Officer',
  'Head of Partnerships',
  'Revenue Operations Manager',
];

export const DEPARTMENTS = [
  'Sales',
  'Marketing',
  'Business Development',
  'Revenue Operations',
  'Customer Success',
  'Partnerships',
  'Growth',
  'Executive Leadership',
  'Operations',
  'Product',
  'Engineering',
  'Finance',
  'Human Resources',
];

export const PAIN_POINTS = [
  'Struggling to generate qualified leads',
  'Low email response rates',
  'Difficulty scaling outreach efforts',
  'Lack of personalized messaging',
  'Time-consuming manual prospecting',
  'Poor lead quality from existing channels',
  'Inefficient sales processes',
  'Limited market reach',
  'Competitor pressure',
  'Need to increase revenue',
  'Long sales cycles',
  'Difficulty identifying decision makers',
];

export const BUYING_SIGNALS = [
  'Recently raised funding',
  'Rapid company growth',
  'New leadership hiring',
  'Technology adoption',
  'Industry expansion',
  'Competitor switching',
  'Job postings increase',
  'Website traffic growth',
  'Social media activity',
  'Event participation',
  'Press releases',
  'Product launches',
];

export const PRIMARY_OBJECTIVES = [
  { value: 'leads', label: 'Generate Qualified Leads', description: 'Focus on building a pipeline of interested prospects' },
  { value: 'meetings', label: 'Book Sales Meetings', description: 'Prioritize getting face-to-face time with prospects' },
  { value: 'sales', label: 'Drive Direct Sales', description: 'Convert prospects to customers quickly' },
  { value: 'brand_awareness', label: 'Build Brand Awareness', description: 'Increase market visibility and recognition' },
];

export const TIMELINES = [
  '1-2 weeks (Quick launch)',
  '2-4 weeks (Standard setup)',
  '1-2 months (Comprehensive campaign)',
  '3+ months (Long-term strategy)',
];

export const VOLUME_EXPECTATIONS = [
  '50-100 contacts per month',
  '100-500 contacts per month',
  '500-1,000 contacts per month',
  '1,000-5,000 contacts per month',
  '5,000+ contacts per month',
];

export const BUDGET_RANGES = [
  'Under $1,000/month',
  '$1,000 - $5,000/month',
  '$5,000 - $10,000/month',
  '$10,000 - $25,000/month',
  '$25,000+ per month',
];

export const OUTREACH_CHANNELS = [
  'Email',
  'LinkedIn',
  'Cold Calling',
  'Social Media',
  'Content Marketing',
  'Events & Webinars',
  'Direct Mail',
  'Referrals',
];

export const TARGETING_SUGGESTIONS = [
  'Companies using specific technologies',
  'Organizations in growth phase',
  'Businesses with recent funding',
  'Companies hiring in key departments',
  'Organizations attending industry events',
  'Businesses with competitor mentions',
  'Companies with website visitor intent',
  'Organizations showing buying behavior',
];

export const CHARACTER_LIMITS = {
  productDescription: 500,
  valueProposition: 300,
  targetDescription: 1000,
  additionalNotes: 500,
} as const; 